<mat-card appearance="outlined">

  <mat-card-content>
      <div class="d-flex m-b-1 justify-content-sb">
        <mat-button-toggle-group name="searchTarget" aria-label="Search Target" [hideSingleSelectionIndicator]="true"
          (change)="searchMatters()">
          <mat-button-toggle value="description">
            <mat-icon>short_text</mat-icon> Description
          </mat-button-toggle>
          <mat-button-toggle value="status">
            <mat-icon>tag</mat-icon> Status
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <mat-form-field appearance="outline" class="search">
        <mat-label>Search -- Search functionality will be implemented in the matter filtering ticket. this is just a placeholder.</mat-label>
        <input matInput placeholder="Search" [formControl]="search" (keyup)="debouncedSearch()" />
        <mat-icon matSuffix *ngIf="search.value" (click)="search.setValue('')" class="cursor-pointer" title="Clear search text">close</mat-icon>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

    <div class="d-flex justify-content-center" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>

    @if (!loading){
      @if (pagedMatters != null) {
        <app-matters-list [pagedMatters]="pagedMatters"></app-matters-list>
      }
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="pagedMatters?.pageSize ?? defaultPagedRequest.pageSize"
        [length]="pagedMatters?.totalCount" showFirstLastButtons aria-label="Select page of Matters"
        (page)="handlePageEvent($event)" [hidden]="pagedMatters?.items?.length === 0"
        [pageIndex]="(pagedMatters?.pageNumber ?? defaultPagedRequest.pageNumber) - 1"></mat-paginator>
    }
  </mat-card-content>
</mat-card>
